// Canonical repo URL. Rendered in `SEE ALSO` on every terminal route.
// Single constant so an org/handle rename is a one-line edit.

export const REPO_URL = 'https://github.com/PilsnerChamp/buddies-onchain';
